<template>
  <vxe-modal ref="modal" v-model="formVisible" title="审批" :width="isMobile ? '80%' : '400px'">
    <el-form size="mini">
      <el-form-item>
        <el-radio-group v-model="ApprovalOpinions">
          <el-radio label="已到款">已到款</el-radio>
          <el-radio label="未到款">未到款</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="审核意见">
        <el-input type="textarea" placeholder="输入" :rows="5" v-model="financial_annotations" />
      </el-form-item>
    </el-form>

    <div style="display: flex;justify-content: flex-end" v-if="!isMobile">
      <el-button @click="closeModal()">取消</el-button>
      <el-button type="primary" @click="confirm()">确认</el-button>
    </div>

    <div style="width: 100%" v-else>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-button style="width: 100%" @click="closeModal()">取消</el-button>
        </el-col>
        <el-col :span="12">
          <el-button type="primary" style="width: 100%" @click="confirm()">确认</el-button>
        </el-col>
      </el-row>
    </div>
  </vxe-modal>
</template>
<script>
export default {
  props: {
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formVisible: false,
      ApprovalOpinions: '已到款',
      // 财务批注
      financial_annotations: ''
    }
  },
  methods: {
    openModal() {
      this.ApprovalOpinions = '已到款'
      this.financial_annotations = ''

      this.formVisible = true
    },
    closeModal() {
      this.formVisible = false
    },
    confirm() {
      this.$emit(
        'sureBack',
        { approve_opinions: this.ApprovalOpinions, financial_annotations: this.financial_annotations },
        'fa'
      )
    }
  }
}
</script>
<style lang="less" scoped></style>
